const GOLOS_NARODA_WIDGET_TYPES = {
  DEFAULT: 'default',
  STATIC: 'static'
};

const GOLOS_NARODA_WIDGET_SLIDE_COUNT = {
  SMALL: 1,
  BIG: 2
};

const PLATFORM_SMARTPHONE = 'smartphone';
const ONE_SLIDE_TO_SHOW = 1;
const TWO_SLIDES_TO_SHOW = 2;
const ONE_SLIDE = 1;

export {
  GOLOS_NARODA_WIDGET_TYPES,
  GOLOS_NARODA_WIDGET_SLIDE_COUNT,
  PLATFORM_SMARTPHONE,
  ONE_SLIDE_TO_SHOW,
  TWO_SLIDES_TO_SHOW,
  ONE_SLIDE
};
